import {
    collection,
    addDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
    query,
    orderBy,
    where
} from 'firebase/firestore';
import { db } from '../../../config/firebase';

export const debtService = {
    // Lấy tất cả nợ của user
    async getDebts(userId) {
        try {
            const q = query(
                collection(db, `users/${userId}/debts`),
                orderBy('createdAt', 'desc')
            );
            const querySnapshot = await getDocs(q);
            return querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                ngayVay: doc.data().ngayVay?.toDate(),
                ngayTra: doc.data().ngayTra?.toDate(),
                createdAt: doc.data().createdAt?.toDate(),
                updatedAt: doc.data().updatedAt?.toDate()
            }));
        } catch (error) {
            console.error('Error fetching debts:', error);
            throw error;
        }
    },

    // Thêm nợ mới
    async addDebt(userId, debtData) {
        try {
            const docRef = await addDoc(collection(db, `users/${userId}/debts`), {
                ...debtData,
                soTienDaTra: 0,
                daTra: false,
                createdAt: new Date(),
                updatedAt: new Date()
            });
            return docRef.id;
        } catch (error) {
            console.error('Error adding debt:', error);
            throw error;
        }
    },

    // Cập nhật nợ
    async updateDebt(userId, debtId, debtData) {
        try {
            await updateDoc(doc(db, `users/${userId}/debts`, debtId), {
                ...debtData,
                updatedAt: new Date()
            });
        } catch (error) {
            console.error('Error updating debt:', error);
            throw error;
        }
    },

    // Xóa nợ
    async deleteDebt(userId, debtId) {
        try {
            await deleteDoc(doc(db, `users/${userId}/debts`, debtId));
        } catch (error) {
            console.error('Error deleting debt:', error);
            throw error;
        }
    },

    // Cập nhật số tiền đã trả
    async updatePaidAmount(userId, debtId, paidAmount, isFullyPaid = false) {
        try {
            await updateDoc(doc(db, `users/${userId}/debts`, debtId), {
                soTienDaTra: paidAmount,
                daTra: isFullyPaid, // Chỉ true khi thực sự trả hết
                updatedAt: new Date()
            });
        } catch (error) {
            console.error('Error updating paid amount:', error);
            throw error;
        }
    }
};
